var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      style: { height: "100%" },
      attrs: { novalidate: "" },
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.onSubmit.apply(null, arguments)
        }
      }
    },
    [
      _c(
        "div",
        { staticClass: "modal-main" },
        [
          _c("h3", [_vm._v("Choose fields to include in report")]),
          _vm._v(" "),
          _vm.showField
            ? _c("select-box", {
                attrs: { label: "Type", "data-list": _vm.typeFields },
                on: { selected: _vm.onTypeSelect }
              })
            : _vm._e(),
          _vm._v(" "),
          !_vm.showField || _vm.form.typeReport === "Rosters"
            ? _c("select-box", {
                attrs: {
                  label: "Fields",
                  multipleSelect: "",
                  "chip-width": _vm.chipWidth,
                  "data-list": _vm.reportFields,
                  "format-callback": function(report) {
                    return report.second
                  }
                },
                on: { selected: _vm.onFieldsNameSelect }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.form.typeReport === "Custom Forms"
            ? _c(
                "div",
                [
                  _c("select-box", {
                    attrs: {
                      label: "Custom Form",
                      "data-list": _vm.filteredForms,
                      placeholder: _vm.placeholderCustomFormSelect,
                      "format-callback": function(form) {
                        return form.formName
                      },
                      disabled: !_vm.filteredForms.length
                    },
                    on: { selected: _vm.onCustomFormSelect }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "form-footer" }, [
        _c(
          "button",
          {
            directives: [
              {
                name: "spinner",
                rawName: "v-spinner",
                value: _vm.isLoading,
                expression: "isLoading"
              }
            ],
            staticClass: "primary-btn btn-center",
            attrs: { disabled: _vm.disabledButton }
          },
          [_vm._v("\n                Download\n            ")]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-47688083", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47688083","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/BulkDownload.vue
// module id = null
// module chunks = 